module.exports = {
  companyAlreadyRegistered: 'E30003',
  emailAlreadyRegistered: 'E30004',
};
